module.exports = __webpack_public_path__ + "img/item2.16ee60b1.png";